
<template>
  <div class="banner-container container-space-y">
    <div class="container">
      <div class="row text-start">
        <div class="col-md-6 col-sm-12"></div>
        <div class="col-md-6 col-sm-12 banner-info">
          <img class="img-responsive alt-adjust" style="height: 60px;"
            src="https://nxmcdn.com/images/NXM/vo-assets/nxm-logo-new.png" alt="NaXum Logo">
          <h1 class="my-5 w-75 banner-heading">Claim your coupon for $20 off your first order (of $115 or more)</h1>
          <button type="button" data-bs-toggle="modal" data-bs-target="#register-modal"
            class="btn btn-block btn-primary w-50">Shop Here</button>


        </div>
      </div>

    </div>
  </div>

  <div class="slider-container container-space-y">
    <div class="container" id="slides">
      <div class="row">
        <div class="col-md-12">
          <div class="mySlides" v-for="(slide, index) in slides" :key="index" :class="{ active: index === activeIndex }">
            <div class="slide-content row">
              <div class="col-md-6">
                <div class="slide-image">
                  <img :src="slide.image" alt="Slide Image" class="img-fluid">
                </div>
              </div>
              <div class="col-md-6">
                <div class="slide-quote">
                  <p class="author">{{ slide.author }}</p>
                  <p class="author-title">{{ slide.title }}</p>
                  <p class="author-quote" v-html="slide.quote"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="dot-container">
            <span class="dot" v-for="(slide, index) in slides" :key="index" :class="{ active: index === activeIndex }"
              @click="goToSlide(index)"></span>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="winning-product-container container-space-y">
    <div class="container">
      <div class="row text-start">
        <div class="col-lg-6 col-md-8 col-xm-12">
          <h2 class="w-title">What to expect when you buy today</h2>
        </div>
        <div class="col-lg-6 col-md-4 col-xm-12">
        </div>
        <div class="col-md-6 col-sm-12 mt-5">
          <ul class="w-custom-list">
            <li>When you purchase today you will be delighted with the luxury global brand product selections you have to
              choose from. At NaXum we only supply genuine, authentic Brand products so you can have confidence when you
              shop.</li>
            <li>As many of our products are sourced globally your delivery time is generally 14 working days. Once your
              parcel arrives at the Auckland Airport you will be emailed a courier tracking number. Locally manufactured
              products will be delivered to you separately within 7 days.</li>
            <li>We find many of our customers have their favourite "collections" of exquisite products to use, so be sure
              to check out our ''Subscribe and Save" customer option.</li>
            <li>Enjoy your customer journey with our team at Naxum, and we look forward to a long relationship with you
              when you join our NaXum Family.</li>
            <li>Should you require any assistance don't hesitate to email us at support@naxum.com</li>
          </ul>
        </div>
        <div class="col-md-4 col-sm-12 text-center">
          <img class="img-responsive mx-auto "
            src="https://nxmcdn.com/images/nxmvue/capture/nxmvue_capture_winning_product_tablet.png"
            alt="Winning Product">
        </div>

      </div>
    </div>
  </div>

  <div class="premium-container container-space-y">
    <div class="container">
      <div class="row text-start">
        <div class="col-md-12 col-xs-12 text-center">
          <h2 class="premium-title text-white">Check out our range of
            premium products - here</h2>
          <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#register-modal">Start with
            nxmdemo</button>
        </div>
      </div>
    </div>
  </div>

  <div class="sponsor-container container-space-y">
    <div class="container">
      <div class="row text-start">
        <div class="col-md-12 col-xs-12 text-center">
          <div class="d-flex justify-content-center align-items-center">
            <img src="https://nxmcdn.com/images/nxmvue/capture/nxmvue_capture_sponsor_image.png" alt="Image"
              class="rounded-circle" style="width: 150px; height: 150px;">
            <div class="ms-3 text-left">
              <h4 class="sponsor_name">nxmdemo</h4>
              <p>+200-8364-9181</p>
              <p>nxm@demo.com</p>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Start Register Now Modal -->
  <div class="modal fade" id="register-modal" tabindex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-lg modal-dialog-centered" role="document">
      <div class="modal-content rounded-0">
        <div class="modal-body p-0">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-5 px-0 d-none d-lg-block">
                <img src="https://nxmcdn.com/images/nxmvue/capture/nxmvue_capture_from.png" alt="" class="img-fluid">
              </div>
              <div class="col-md-12 col-lg-7 text-center px-0">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                <form @submit.prevent="submitForm" id="signupform" class="signupform">

                  <!-- HONEYPOT FIELDS START -->

                  <div class="form-group">
                    <input type="hidden" id="firstname" name="firstname" class="form-control" placeholder=""
                      maxlength="50" v-model="honeyPot.firstname" autocomplete="off">
                  </div>
                  <div class="form-group">
                    <input type="hidden" id="lastname" name="lastname" class="form-control" placeholder="" maxlength="50"
                      v-model="honeyPot.lastname" autocomplete="off">
                  </div>

                  <!--  HONEYPOT FIELDS END -->

                  <div class="form-group">
                    <input type="text" class="form-control " id="fname" name="fname" placeholder="First Name"
                      maxlength="30" v-model="fName" :class="{ 'is-invalid': errors.fName }" />
                    <span v-if="errors.fName" class="error">{{ errors.fName }}</span>
                  </div>

                  <div class="form-group">
                    <input type="text" class="form-control " id="lname" name="lname" placeholder="Last Name"
                      maxlength="30" v-model="lName" :class="{ 'is-invalid': errors.lName }" />
                    <span v-if="errors.lName" class="error">{{ errors.lName }}</span>
                  </div>

                  <div class="form-group">
                    <input type="number" class="form-control " placeholder="Mobile" name="cellphone" id="cellphone"
                      v-model="cellphone" :class="{ 'is-invalid': errors.cellphone }" />
                    <span v-if="errors.cellphone" class="error">{{ errors.cellphone }}</span>
                  </div>

                  <div class="form-group">
                    <input type="email" class="form-control " placeholder="Email" name="email" id="email" maxlength="50"
                      v-model="email" :class="{ 'is-invalid': errors.email }" />
                    <span v-if="errors.email" class="error">{{ errors.email }}</span>
                  </div>

                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Town" name="town" id="town" />
                  </div>


                  <div class="form-group">
                    <div class="recaptcha-container" id="recaptchaContainer" ref="recaptchaContainer"></div>
                    <div>
                      <span v-if="recaptchaError" class="error">{{ recaptchaError }}</span>
                    </div>
                  </div>

                  <button type="submit" class="btn btn-submit py-3 w-100  mt-3" id="registernow"
                    @click="submitForm">Register
                    Now</button>
                </form>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- EndRegister Now Modal -->
</template>

<script>
/* global grecaptcha */
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
export default {
  name: 'FormValidation',
  data() {
    return {
      fName: '',
      lName: '',
      email: '',
      cellphone: '',
      errors: {
        fName: '',
        lName: '',
        email: '',
        cellphone: '',
      },
      showModal: false,
      activeIndex: 0,
      slides: [
        {
          image: 'https://nxmcdn.com/images/nxmvue/capture/nxmvue_capture_slider_1.png',
          quote: 'It was so much fun to host an event for my friends to experience global branded products at my home.<br><br>Best girls night out ever!!',
          author: 'ELAINE 1',
          title: 'Host from Napier'
        },
        {
          image: 'https://nxmcdn.com/images/nxmvue/capture/nxmvue_capture_slider_2.png',
          quote: 'It was so much fun to host an event for my friends to experience global branded products at my home.<br><br>Best girls night out ever!!',
          author: 'ELAINE 2',
          title: 'Host from Napier 2'
        },
        {
          image: 'https://nxmcdn.com/images/nxmvue/capture/nxmvue_capture_slider_3.png',
          quote: 'It was so much fun to host an event for my friends to experience global branded products at my home.<br><br>Best girls night out ever!!',
          author: 'ELAINE 3',
          title: 'Host from Napier 3'
        }
      ],
      honeyPot: {
        firstname: '',
        lastname: '',
      },
      recaptchaToken: '',
      recaptchaError: '',

    };
  },
  mounted() {
    this.startAutoplay();
    this.loadRecaptchaScript();
  },
  beforeUnmounted() {
    this.stopAutoplay();
  },
  methods: {
    // Slider methods
    goToSlide(index) {
      this.activeIndex = index;
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    nextSlide() {
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
    },

    // Form validation methods
    validateForm() {
      let isValid = true;

      // Clear previous errors
      this.errors.fName = '';
      this.errors.lName = '';
      this.errors.email = '';
      this.errors.cellphone = '';

      // Honeypot field validation
      if (this.honeyPot.firstname || this.honeyPot.lastname) {
        // Honeypot field has a value, indicating it's being filled by a bot
        console.log('Honeypot validation failed');
        isValid = false;
        return isValid;
      }

      // Name validation
      if (!this.fName) {
        this.errors.fName = 'First Name is required.';
        isValid = false;
      }
      if (!this.lName) {
        this.errors.lName = 'Last Name is required.';
        isValid = false;
      }

      // Email validation
      if (!this.email) {
        this.errors.email = 'Email is required.';
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.errors.email = 'Invalid email format.';
        isValid = false;
      }

      // Cellphone validation
      if (!this.cellphone) {
        this.errors.cellphone = 'Mobile is required.';
        isValid = false;
      } else if (!this.isValidCellphone(this.cellphone)) {
        this.errors.cellphone = 'Invalid Mobile format.';
        isValid = false;
      }



      return isValid;
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    isValidCellphone(cellphone) {
      const cellphoneRegex = /^\d{7,20}$/;
      return cellphoneRegex.test(cellphone);
    },

    // reCAPTCHA methods
    loadRecaptchaScript() {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; // Replace with your actual sitekey
      script.async = true;
      script.defer = true;
      script.onload = this.renderRecaptcha;
      document.head.appendChild(script);
    },

    renderRecaptcha() {
      grecaptcha.ready(() => {
        grecaptcha.render(this.$refs.recaptchaContainer, {
          sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // Replace with your actual sitekey
          callback: this.onRecaptchaVerified
        });
      });
    },

    onRecaptchaVerified(response) {
      console.log('reCAPTCHA verified:', response);
      this.recaptchaToken = response;
    },

    executeRecaptcha() {
      grecaptcha.execute('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', { action: 'submit' }).then(token => { // Replace with your actual sitekey
        console.log('reCAPTCHA Token:', token);
        this.submitForm();
      });
    },
    submitForm() {
      if (!this.honeyPot.firstname && !this.honeyPot.lastname && this.validateForm()) {
        // Form is valid, perform the desired action
        if (this.recaptchaToken !== '') {
          // reCAPTCHA is verified, perform the desired action
          console.log('Form submitted successfully');
          // You can add your form submission logic here
          // Display SweetAlert success message
          Swal.fire({
            icon: 'success',
            title: 'Form submitted successfully!',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            // Hide the modal
            const modalElement = document.getElementById('register-modal');
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
            modalBackdrop.parentNode.removeChild(modalBackdrop);
            // Refresh the page
            location.reload();
          })
        } else {
          this.recaptchaError = 'Please confirm the captcha';
        }
      } else {
        this.recaptchaError = 'Please confirm the captcha';
      }
    },
  },
};
</script>

